import { render, staticRenderFns } from "./BenutzerListe.vue?vue&type=template&id=0aa9fc8e"
import script from "./BenutzerListe.vue?vue&type=script&lang=js"
export * from "./BenutzerListe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports